export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkAbout: "nav-link-about",
  linkPrograms: "nav-link-programs",
  linkTravel: "nav-link-travel",
  linkTestimonials: "nav-link-testimonials",
  linkContact: "nav-link-contact",
  ctaJoin: "nav-cta-join",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
  locationBadge: "hero-location-badge",
};

export const ABOUT = {
  section: "about-section",
};

export const PROGRAMS = {
  section: "programs-section",
  cardSkill: "program-card-skill",
  cardShooting: "program-card-shooting",
  cardPosition: "program-card-position",
  cardFilm: "program-card-film",
};

export const TRAVEL = {
  section: "travel-section",
  ctaInquiry: "travel-cta-inquiry",
};

export const TESTIMONIALS = {
  section: "testimonials-section",
};

export const CONTACT = {
  section: "contact-section",
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputPhone: "contact-input-phone",
  inputAge: "contact-input-age",
  selectProgram: "contact-select-program",
  inputMessage: "contact-input-message",
  submit: "contact-submit",
  successMsg: "contact-success-msg",
  emailLink: "contact-email-link",
  instagramLink: "contact-instagram-link",
};

export const FOOTER = {
  section: "footer-section",
  instagramLink: "footer-instagram-link",
  emailLink: "footer-email-link",
};

export const INTEREST = {
  navTrigger: "nav-cta-interest",
  heroTrigger: "hero-cta-interest",
  sponsorshipTrigger: "sponsorship-cta-interest",
  dialog: "interest-dialog",
  form: "interest-form",
  inputPlayer: "interest-input-player",
  inputParent: "interest-input-parent",
  inputEmail: "interest-input-email",
  inputPhone: "interest-input-phone",
  inputGrade: "interest-input-grade",
  inputPosition: "interest-input-position",
  inputTeam: "interest-input-team",
  inputSponsorship: "interest-input-sponsorship",
  inputMessage: "interest-input-message",
  submit: "interest-submit",
  success: "interest-success",
  closeSuccess: "interest-close-success",
};

export const SPONSORSHIP = {
  section: "sponsorship-section",
  ctaTrigger: "sponsorship-cta-trigger",
};

export const ADMIN = {
  loginForm: "admin-login-form",
  loginInput: "admin-login-input",
  loginSubmit: "admin-login-submit",
  loginError: "admin-login-error",
  dashboard: "admin-dashboard",
  logout: "admin-logout",
  tabContacts: "admin-tab-contacts",
  tabInterest: "admin-tab-interest",
  summaryContacts: "admin-summary-contacts",
  summaryInterest: "admin-summary-interest",
  summarySponsorship: "admin-summary-sponsorship",
  emailStatus: "admin-email-status",
  contactsList: "admin-contacts-list",
  interestList: "admin-interest-list",
  refresh: "admin-refresh",
};
